import React, { FC, useState, useEffect, useContext } from 'react';

import { SelectedIndexContext } from '../../App';
import { MatchEntry } from './match-entry/ryder-cup/mach-entry';
import { useFetchResultsAwaitingScores, ResultAwaitingScores } from '../../api/hooks/use-fetch-results-awaiting-scores';
import { EditResults } from '../results/ryderCup/edit-results';
import { Matches } from '../../../database.schema';

const initialMatches: Matches = {
  courseId: -1,
  format: 'Pairs',
  matches: [],
  startingHole: 1,
};

export const CreateMatch: FC = (): JSX.Element => {
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const { data, isLoading, error } = useFetchResultsAwaitingScores(selectedTournamentIndex);
  const [showMatches, setShowMatches] = useState(true);
  const [recordedMatches, setRecordedMatches] = useState<Matches>(initialMatches);
  const [resultIndexStore, setResultIndexStore] = useState<number>(-1);

  useEffect(() => {
    if (data) {
      const { matches, resultIndex } = data as ResultAwaitingScores;
      setResultIndexStore(resultIndex);
      if (matches) {
        setRecordedMatches({ ...(matches || []) });
        setShowMatches(true);
      }
    }
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.log('<><CreateMatchError><>', error);
    return <div>Error...</div>;
  }
  if (resultIndexStore > -1) {
    return <EditResults dayIndex={resultIndexStore} selectedTournamentIndex={selectedTournamentIndex} />;
  }
  return <MatchEntry recordedMatches={recordedMatches} setShowReset={setShowMatches} />;
};
